import React, { FunctionComponent } from "react";
import styles from "../styles/HorizontalSeparator.module.scss"

interface HorizontalSeparatorProps {
    text: string
}
 
const HorizontalSeparator: FunctionComponent<HorizontalSeparatorProps> = ({text}) => {
    return (
        <div className={styles.separatorContainer}>
        <div className={styles.leftLine} />

        <div>
          <p className={styles.text}>{text}</p>
        </div>

        <div className={styles.rightLine} />
      </div>
    );
}
 
export default HorizontalSeparator;